<template>
  <div class="d-inline-block">
    <template v-if="$vuetify.breakpoint.smAndDown">
      <v-menu left>
        <template v-slot:activator="{ on }">
          <v-btn color="kbDarkBlueText"
                 icon
                 v-on="on">
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>

        <v-row>
          <v-col cols="12" class="py-0">
            <v-list color="kbLight">
              <template v-for="(contactMethod, index) in contactMethods">
                <v-list-item :key="`contactMethod-${index}`"
                             style="position: relative"
                             v-if="contactMethod.condition"
                             @click="contactMethod.function()">
                  <v-list-item-content>
                    <v-list-item-title class="kbDarkBlueText--text d-flex align-center">
                      <v-icon color="kbDarkBlueText" class="mr-3">
                        {{ contactMethod.icon }}
                      </v-icon>
                      {{ contactMethod.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="`divider-${index}`" v-if="index < contactMethods.length - 1" />
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-menu>
    </template>

    <template v-else>
      <div>
        <v-btn icon
               :color="mainColor"
               large
               v-if="socialNetworksRegistered.facebook">
          <v-icon size="30px">mdi-facebook</v-icon>
        </v-btn>

        <v-btn icon
               :color="mainColor"
               large
               v-if="socialNetworksRegistered.instagram">
          <v-icon size="30px">mdi-instagram</v-icon>
        </v-btn>

        <v-btn icon
               :color="mainColor"
               large
               v-if="socialNetworksRegistered.spotify">
          <v-icon size="30px">mdi-spotify</v-icon>
        </v-btn>

        <v-tooltip bottom v-if="selectedUser.email">
          <template v-slot:activator="{ on }">
            <v-btn icon
                   :color="mainColor"
                   large
                   v-on="on"
                   @click="openEmailComposerDialog()">
              <v-icon size="30px">mdi-email-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.sendEmailTo') }} {{ selectedUser.name || selectedUser.email }}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="selectedUser.phone">
          <template v-slot:activator="{ on }">
            <v-btn icon
                   @click="changeCurrentComponent('SendSms')"
                   :color="mainColor"
                   large
                   v-on="on">
              <v-icon size="30px">
                feather-message-square
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.sendSMSTo') }} {{ selectedUser.name || selectedUser.phone }}</span>
        </v-tooltip>

        <span v-if="selectedUser.phone && showInitWhatsAppCoversationButtons">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="initWhatsAppConversation()"
                     :color="mainColor"
                     icon
                     large
                     v-if="channelsWithWhatsApp.length < 2"
                     v-on="on">
                <v-icon size="30px">
                  mdi-whatsapp
                </v-icon>
              </v-btn>
            </template>

            <span>{{channelsWithWhatsApp.length === 0 ? $t('general.activateWhatsappBusiness') : $t('general.initWhatsappConversation') }}</span>
          </v-tooltip>

          <v-menu>
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn icon
                         :color="mainColor"
                         large
                         v-bind="attrs"
                         v-if="channelsWithWhatsApp.length > 1"
                         v-on="{...menu, ...tooltip}">
                    <v-icon size="30px">
                      mdi-whatsapp
                    </v-icon>
                  </v-btn>
                </template>

                <span>{{ $t('general.initWhatsappConversation') }}</span>
              </v-tooltip>
            </template>

            <v-list>
              <v-list-item @click="initWhatsAppConversation(agent.id)"
                           v-for="agent in channelsWithWhatsApp"
                           :key="agent.id">
                <v-list-item-title>
                  {{ agent.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapGetters(['sidebarModules']),
    ...mapState({
      administratorRoles: state => state.companies.administratorRoles,
      channelsWithWhatsApp: state => state.conversations.channelsWithWhatsApp,
      selectedUser: state => state.users.selectedUser,
      userKeybe: state => state.auth.userKeybe
    }),
    contactMethods () {
      const vue = this
      let contactMethods = [
        {
          name: this.$t('general.sendEmailTo') + ' ' + this.selectedUser.email,
          icon: 'mdi-email-outline',
          condition: vue.selectedUser.email,
          function () { vue.openEmailComposerDialog() }
        },
        {
          name: this.$t('general.sendSMSTo') + ' ' + this.selectedUser.phone,
          icon: 'feather-message-square',
          condition: vue.selectedUser.phone,
          function () { vue.changeCurrentComponent('SendSms') }
        }
      ]
      if (this.channelsWithWhatsApp &&
          Array.isArray(this.channelsWithWhatsApp) &&
          this.channelsWithWhatsApp.length &&
          this.showInitWhatsAppCoversationButtons) {
        const modifiedChannelsWithWhatsApp = this.channelsWithWhatsApp.map(channel => {
          return {
            name: `${this.$t('general.initConversationWithWhatsappChannel', { channel: channel.name })}`,
            icon: 'mdi-whatsapp',
            condition: true,
            function () { vue.initWhatsAppConversation(channel.id) }
          }
        })
        contactMethods = [...contactMethods, ...modifiedChannelsWithWhatsApp]
      }
      return contactMethods
    },
    showInitWhatsAppCoversationButtons () {
      return this.administratorRoles.includes('ROLE_ADMIN') ||
        this.userKeybe.type === 'superadmin' ||
        (
          this.administratorRoles.includes('ROLE_CONVERSATIONS') &&
          this.sidebarModules.includes('sidebar-conversations')
        )
    }
  },
  methods: {
    changeCurrentComponent (component) {
      this.$emit('changeCurrentComponent', component)
    },
    initWhatsAppConversation (id) {
      if (this.channelsWithWhatsApp.length === 0) {
        return window.keybe.openChat({ message: 'Hola, quiero activar WhatsApp Business oficial en mi negocio' })
      }

      if (!id) id = this.channelsWithWhatsApp[0].id

      const data = {
        country: this.selectedUser.country,
        phone: this.selectedUser.phone,
        id: id
      }

      this.$store.commit('SET_INIT_CONVERSATION', data)
      this.$router.push('/conversations')
    },
    openEmailComposerDialog () {
      this.$emit('openEmailComposerDialog')
    }
  },
  props: {
    mainColor: {
      type: String
    },
    socialNetworksRegistered: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
